import React from 'react';
import { BoldLink } from '@bold/web-components-react';
import SegmentButton from 'components/website/SegmentButton';

import './article-card.scss';

const ArticleCard = ({ link, image, title, excerpt }) => {
  return (
    <article className="article-slide-item" type="button">
      <SegmentButton
        event="button"
        isLink
        isBlank
        url={link}
        obj={{
          redirect_to: link,
          page_section: 'noticias',
        }}
      >
        <div className="article-slide-image">{image}</div>

        <div className="article-info">
          <h3>{title}</h3>
          <p>{excerpt}</p>
          <BoldLink className="mt-24" color="accent">
            Ver más
          </BoldLink>
        </div>
      </SegmentButton>
    </article>
  );
};

export default ArticleCard;
